<div class="benefits-container">
  <div class="benefits-content">
    <div class="benefit-title">
      {{landingCMSData?.loyaltyEcosystemBenefitsTitle}}
    </div>

    <owl-carousel-o [options]="carouselOptions" class="carousel-container">
      <ng-container *ngFor="let card of cardList" class="carousel-items">
        <ng-template carouselSlide>
          <div class="card">
            <div class="card-image-container">
              <img [src]="'https:' + card.fields.cardImage.fields.file.url" alt="Card Image" class="program-card-image">
            </div>
            <!-- <div class="card-title">{{ card.fields.cardTitle }}</div>
            <div class="card-desc">{{ card.fields.cardDesc }}</div> -->
          </div>
        </ng-template>
      </ng-container>
    </owl-carousel-o>

  </div>
</div>